import { IconBarcode, IconCreditCard, IconBolt } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import type { PaymentMethod } from "../api";

interface Props {
  method: PaymentMethod;
  withLabel?: boolean;
  className?: string;
}

export function PaymentMethodLabel({ method, withLabel = true, className }: Props) {
  const { t } = useTranslation(undefined, { keyPrefix: "subscription" });

  const Icon =
    method === "boleto" ? IconBarcode : method === "pix" ? IconBolt : IconCreditCard;

  return (
    <span className={`inline-flex items-center gap-1.5 ${className ?? ""}`}>
      <Icon size={14} className="text-ink-muted" aria-hidden />
      {withLabel && <span className="text-[12.5px] text-ink">{t(`method.${method}`)}</span>}
    </span>
  );
}
